// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/react-pivottable/pivottable.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
.output-terminal {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-color);
  background: var(--primary-surface-color);
  align-self: stretch;
  /* Hide scrollbar for Chrome, Safari and Opera */
  /* Hide scrollbar for IE, Edge and Firefox */
}
.output-terminal::-webkit-scrollbar {
  display: none;
}
.output-terminal {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
@media (max-width: 1024px) {
  .output-terminal {
    height: 70vh;
  }
}
.output-terminal__pivot-table {
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-right: 1px solid var(--border-color);
  background: var(--accent-exceptional-tertiary-blue-color);
  color: var(--tertiary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
  cursor: pointer;
}
.output-terminal__pivot-table.active {
  color: var(--accent-exceptional-primary-blue-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
  border-bottom: 3px solid var(--Color-Accent-Shade-1, #5095fc);
  background: var(--accent-tertiary-blue-color);
}
.output-terminal__pivot-table:last-child {
  border-right: none;
}

.output-terminal-header-section {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  align-self: stretch;
  border-bottom: 1px solid var(--border-color);
  background: var(--accent-exceptional-tertiary-blue-color);
}

.output-terminal-content {
  flex-grow: 1;
  overflow-y: auto;
  height: calc(40vh - 62px - 82px);
  max-width: calc(100vw - 63px);
  padding-bottom: 90px;
  padding-bottom: 200px;
}
@media (max-width: 1024px) {
  .output-terminal-content {
    height: calc(70vh - 62px);
    flex-grow: unset;
    padding-bottom: unset;
    scrollbar-width: none;
  }
}

.pvtUi {
  color: var(--primary-text-color);
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  background-color: var(--main-surface-color);
  padding: 10px;
}

.pvtUi select {
  user-select: none;
}

.pvtTable {
  font-size: 10pt;
  text-align: left;
  border-collapse: collapse;
  width: 100%;
  font-family: Verdana, sans-serif;
  background-color: var(--primary-surface-color);
}

.pvtTable thead th,
.pvtTable tbody th {
  background-color: var(--accent-tertiary-blue-color);
  border: 1px solid var(--border-color);
  padding: 8px;
  font-size: 10pt;
  font-weight: bold;
  color: var(--primary-text-color);
}

.pvtTable tbody td {
  padding: 8px;
  background-color: var(--primary-surface-color);
  border: 1px solid var(--border-color);
  text-align: right;
  color: var(--secondary-text-color);
}

.pvtAxisContainer,
.pvtVals {
  border: 1px solid var(--border-color);
  background: var(--secondary-surface-color);
  padding: 5px;
  min-width: 20px;
  min-height: 20px;
  color: var(--tertiary-text-color);
}

.pvtDropdown {
  display: inline-block;
  position: relative;
  margin: 3px;
}

.pvtDropdownCurrent {
  text-align: left;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  display: inline-block;
  width: 210px;
  background: var(--primary-surface-color);
  color: var(--primary-text-color);
}

.pvtDropdownMenu {
  background: var(--primary-surface-color);
  position: absolute;
  width: 100%;
  border-radius: 0 0 4px 4px;
  border: 1px solid var(--border-color);
}

.pvtButton {
  color: var(--primary-text-color);
  border-radius: 5px;
  padding: 5px 10px;
  background: var(--secondary-surface-color);
  border: 1px solid var(--border-color);
  font-size: 12px;
  transition: 0.3s ease;
  cursor: pointer;
}

.pvtButton:hover {
  background: var(--tertiary-surface-color);
}

.pvtButton:active {
  background: var(--quartinary-surface-color);
}

.pvtFilterBox {
  width: 300px;
  border: 1px solid var(--border-color);
  background-color: var(--primary-surface-color);
  position: absolute;
  text-align: center;
  min-height: 100px;
  color: var(--primary-text-color);
}

.pvtFilterBox input {
  border: 1px solid var(--border-color);
  border-radius: 5px;
  padding: 5px;
  font-size: 12px;
  color: var(--secondary-text-color);
}

.pvtCheckContainer {
  text-align: left;
  font-size: 12px;
  overflow-y: auto;
  width: 100%;
  max-height: 30vh;
  border-top: 1px solid var(--border-color);
  background: var(--tertiary-surface-color);
}

.pvtCheckContainer p {
  margin: 0;
  padding: 5px;
  cursor: pointer;
}

.pvtCheckContainer p.selected {
  background: none !important;
}

.pvtRendererArea {
  padding: 5px;
}

.pvtAxisContainer li span.pvtAttr {
  background: var(--tertiary-surface-color);
  border: 1px solid var(--border-color);
}

table.pvtTable tbody tr th {
  background-color: var(--quartinary-surface-color);
  border: 1px solid var(--border-color);
}

.pvtTotal,
.pvtGrandTotal {
  font-weight: bold;
  background-color: var(--accent-quartinary-blue-color);
}

table.pvtTable tbody tr td {
  background-color: var(--tertiary-surface-color);
  border: 1px solid var(--border-color);
  color: var(--secondary-text-color);
}

.pvtDropdownActiveValue {
  background-color: var(--quartinary-surface-color);
}

table.pvtTable thead tr th,
table.pvtTable tbody tr th {
  background-color: var(--quartinary-surface-color);
  color: var(--secondary-text-color);
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/components/OutputTerminal/outputTerminal.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACCF;ADEA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACDF;ADGA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACFF;ADIA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACHF;AArBA;EAEE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,wCAAA;EACA,mBAAA;ECyLA,gDAAA;EAKA,4CAAA;ADtKF;ACkKE;EACE,aAAA;ADhKJ;ACoKE;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;ADlKJ;AC4DE;EDnGF;IAYI,YAAA;EA+BF;AACF;AA7BE;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,2CAAA;EACA,yDAAA;EACA,iCAAA;ECgBF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDhBE,eAAA;EACA,iBAAA,EAAA,WAAA;EACA,eAAA;AAiCJ;AA/BI;EACE,mDAAA;ECSJ,oCAAA;EACA,kBAAA;EACA,gBAAA;EDTI,eAAA;EACA,iBAAA,EAAA,WAAA;EACA,6DAAA;EACA,6CAAA;AAmCN;AAhCE;EACE,kBAAA;AAkCJ;;AA9BA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,4CAAA;EACA,yDAAA;AAiCF;;AA9BA;EACE,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,6BAAA;EACA,oBAAA;EAOA,qBAAA;AA2BF;ACME;ED7CF;IAOI,yBAAA;IACA,gBAAA;IACA,qBAAA;IACA,qBAAA;EAoCF;AACF;;AAhCA;EACE,gCAAA;EACA,gCAAA;EACA,yBAAA;EACA,2CAAA;EACA,aAAA;AAmCF;;AAhCA;EACE,iBAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,gCAAA;EACA,8CAAA;AAmCF;;AAhCA;;EAEE,mDAAA;EACA,qCAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AAmCF;;AAhCA;EACE,YAAA;EACA,8CAAA;EACA,qCAAA;EACA,iBAAA;EACA,kCAAA;AAmCF;;AAhCA;;EAEE,qCAAA;EACA,0CAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAmCF;;AAhCA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;AAmCF;;AAhCA;EACE,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,wCAAA;EACA,gCAAA;AAmCF;;AAhCA;EACE,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,qCAAA;AAmCF;;AAhCA;EACE,gCAAA;EACA,kBAAA;EACA,iBAAA;EACA,0CAAA;EACA,qCAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AAmCF;;AAhCA;EACE,yCAAA;AAmCF;;AAhCA;EACE,2CAAA;AAmCF;;AAhCA;EACE,YAAA;EACA,qCAAA;EACA,8CAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;AAmCF;;AAhCA;EACE,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;AAmCF;;AAhCA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,yCAAA;EACA,yCAAA;AAmCF;;AAhCA;EACE,SAAA;EACA,YAAA;EACA,eAAA;AAmCF;;AAhCA;EACE,2BAAA;AAmCF;;AAhCA;EACE,YAAA;AAmCF;;AAhCA;EACE,yCAAA;EACA,qCAAA;AAmCF;;AAhCA;EACE,iDAAA;EACA,qCAAA;AAmCF;;AAhCA;;EAEE,iBAAA;EACA,qDAAA;AAmCF;;AAhCA;EACE,+CAAA;EACA,qCAAA;EACA,kCAAA;AAmCF;;AAhCA;EACE,iDAAA;AAmCF;;AAhCA;;EAEE,iDAAA;EACA,kCAAA;AAmCF","sourcesContent":["@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@import '../..//styles/styles.scss';\n@import 'react-pivottable/pivottable.css';\n\n.output-terminal {\n  // padding: 24px 0px 0px 24px;\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--border-color);\n  background: var(--primary-surface-color);\n  align-self: stretch;\n  @include hide_scrollbar;\n\n  @include respond-to(1024px) {\n    height: 70vh;\n  }\n\n  &__pivot-table {\n    display: flex;\n    padding: 16px 24px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    border-right: 1px solid var(--border-color);\n    background: var(--accent-exceptional-tertiary-blue-color);\n    color: var(--tertiary-text-color);\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n    cursor: pointer;\n\n    &.active {\n      color: var(--accent-exceptional-primary-blue-color);\n      @include SemiSans;\n      font-size: 14px;\n      line-height: 125%; /* 17.5px */\n      border-bottom: 3px solid var(--Color-Accent-Shade-1, #5095fc);\n      background: var(--accent-tertiary-blue-color);\n    }\n  }\n  &__pivot-table:last-child {\n    border-right: none;\n  }\n}\n\n.output-terminal-header-section {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  border-bottom: 1px solid var(--border-color);\n  background: var(--accent-exceptional-tertiary-blue-color);\n}\n\n.output-terminal-content {\n  flex-grow: 1;\n  overflow-y: auto;\n  height: calc(40vh - 62px - 82px);\n  max-width: calc(100vw - 63px);\n  padding-bottom: 90px;\n  @include respond-to(1024px) {\n    height: calc(70vh - 62px);\n    flex-grow: unset;\n    padding-bottom: unset;\n    scrollbar-width: none;\n  }\n  padding-bottom: 200px\n}\n\n.pvtUi {\n  color: var(--primary-text-color);\n  font-family: Verdana, sans-serif;\n  border-collapse: collapse;\n  background-color: var(--main-surface-color);\n  padding: 10px;\n}\n\n.pvtUi select {\n  user-select: none;\n}\n\n.pvtTable {\n  font-size: 10pt;\n  text-align: left;\n  border-collapse: collapse;\n  width: 100%;\n  font-family: Verdana, sans-serif;\n  background-color: var(--primary-surface-color);\n}\n\n.pvtTable thead th,\n.pvtTable tbody th {\n  background-color: var(--accent-tertiary-blue-color);\n  border: 1px solid var(--border-color);\n  padding: 8px;\n  font-size: 10pt;\n  font-weight: bold;\n  color: var(--primary-text-color);\n}\n\n.pvtTable tbody td {\n  padding: 8px;\n  background-color: var(--primary-surface-color);\n  border: 1px solid var(--border-color);\n  text-align: right;\n  color: var(--secondary-text-color);\n}\n\n.pvtAxisContainer,\n.pvtVals {\n  border: 1px solid var(--border-color);\n  background: var(--secondary-surface-color);\n  padding: 5px;\n  min-width: 20px;\n  min-height: 20px;\n  color: var(--tertiary-text-color);\n}\n\n.pvtDropdown {\n  display: inline-block;\n  position: relative;\n  margin: 3px;\n}\n\n.pvtDropdownCurrent {\n  text-align: left;\n  border: 1px solid var(--border-color);\n  border-radius: 4px;\n  display: inline-block;\n  width: 210px;\n  background: var(--primary-surface-color);\n  color: var(--primary-text-color);\n}\n\n.pvtDropdownMenu {\n  background: var(--primary-surface-color);\n  position: absolute;\n  width: 100%;\n  border-radius: 0 0 4px 4px;\n  border: 1px solid var(--border-color);\n}\n\n.pvtButton {\n  color: var(--primary-text-color);\n  border-radius: 5px;\n  padding: 5px 10px;\n  background: var(--secondary-surface-color);\n  border: 1px solid var(--border-color);\n  font-size: 12px;\n  transition: 0.3s ease;\n  cursor: pointer;\n}\n\n.pvtButton:hover {\n  background: var(--tertiary-surface-color);\n}\n\n.pvtButton:active {\n  background: var(--quartinary-surface-color);\n}\n\n.pvtFilterBox {\n  width: 300px;\n  border: 1px solid var(--border-color);\n  background-color: var(--primary-surface-color);\n  position: absolute;\n  text-align: center;\n  min-height: 100px;\n  color: var(--primary-text-color);\n}\n\n.pvtFilterBox input {\n  border: 1px solid var(--border-color);\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 12px;\n  color: var(--secondary-text-color);\n}\n\n.pvtCheckContainer {\n  text-align: left;\n  font-size: 12px;\n  overflow-y: auto;\n  width: 100%;\n  max-height: 30vh;\n  border-top: 1px solid var(--border-color);\n  background: var(--tertiary-surface-color);\n}\n\n.pvtCheckContainer p {\n  margin: 0;\n  padding: 5px;\n  cursor: pointer;\n}\n\n.pvtCheckContainer p.selected {\n  background: none !important;\n}\n\n.pvtRendererArea {\n  padding: 5px;\n}\n\n.pvtAxisContainer li span.pvtAttr {\n  background: var(--tertiary-surface-color);\n  border: 1px solid var(--border-color);\n}\n\ntable.pvtTable tbody tr th {\n  background-color: var(--quartinary-surface-color);\n  border: 1px solid var(--border-color);\n}\n\n.pvtTotal,\n.pvtGrandTotal {\n  font-weight: bold;\n  background-color: var(--accent-quartinary-blue-color);\n}\n\ntable.pvtTable tbody tr td {\n  background-color: var(--tertiary-surface-color);\n  border: 1px solid var(--border-color);\n  color: var(--secondary-text-color);\n}\n\n.pvtDropdownActiveValue {\n  background-color: var(--quartinary-surface-color);\n}\n\ntable.pvtTable thead tr th,\ntable.pvtTable tbody tr th {\n  background-color: var(--quartinary-surface-color);\n  color: var(--secondary-text-color);\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
